<template>
    <div class="bg_white">
      <van-nav-bar title="会员单位申请" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
        <template #right>
          <van-icon name="wap-home-o" size="20" />
        </template>
      </van-nav-bar>

      

      <van-cell-group>
        <van-field v-model="orgType" label="会员类别" placeholder="请选择会员类别" right-icon="arrow"
        @click="showOrgTypePick = true" />
      <van-popup v-model="showOrgTypePick" round position="bottom">
        <van-picker show-toolbar :columns="member_type_list" @cancel="showOrgTypePick = false"
          @confirm="confirmOrgType" value-key="dictLabel" />
      </van-popup>

      <van-field v-model="orgIndustry" label="行业类别" placeholder="请选择行业类别" right-icon="arrow"
        @click="showOrgMemberIndustry = true" />
      <van-popup v-model="showOrgMemberIndustry" round position="bottom">
        <van-picker show-toolbar :columns="member_industry_list" @cancel="showOrgMemberIndustry = false"
          @confirm="confirmOrgIndustry" value-key="dictLabel" />
      </van-popup>

        <van-field v-model="param.orgName" label="单位名称：" placeholder="请输入单位名称" />
        

        <van-field v-model="orgNature" label="单位性质" placeholder="请选择单位性质" right-icon="arrow"
        @click="showOrgNaturePick = true" />
        <van-popup v-model="showOrgNaturePick" round position="bottom">
            <van-picker show-toolbar :columns="org_nature_list" @cancel="showOrgNaturePick = false"
            @confirm="confirmOrNature" value-key="dictLabel" />
        </van-popup>

        <van-field v-model="param.orgFrName" label="法人姓名：" placeholder="请输入法人姓名" />

        <van-field v-model="orgMemberJob" label="职务" placeholder="请选择法人职务" right-icon="arrow"
        @click="showOrgMemberJobPick = true" />
        <van-popup v-model="showOrgMemberJobPick" round position="bottom">
            <van-picker show-toolbar :columns="member_job_list" @cancel="showOrgMemberJobPick = false"
            @confirm="confirmOrgMemberJob" value-key="dictLabel" />
        </van-popup>

        <van-field v-model="param.orgFrPhone" label="电话号码：" placeholder="法人电话号码" />

        <van-field v-model="param.orgDirectorName" label="分管安全负责人：" placeholder="分管安全负责人姓名" />
        <van-field v-model="param.orgDirectorPhone" label="电话号码：" placeholder="分管安全负责人电话号码" />

        <van-field v-model="param.contactName" label="经办联系人：" placeholder="经办联系人姓名" />
        <van-field v-model="param.contactPhone" label="电话号码：" placeholder="经办联系人电话号码" />

        <van-field v-model="param.orgTel" label="固定号码：" placeholder="请输入单位固定号码" />
        <van-field v-model="param.orgAddress" label="联系地址" placeholder="请输入单位联系地址" />
        <van-field v-model="param.mailCode" label="邮编" placeholder="请输入单位邮编" />
        <van-field v-model="param.reasons" label="申请理由" placeholder="入会申请理由" />
        <van-field v-model="param.remarks" label="备注" placeholder="备注" />
      </van-cell-group>
  
      <div class="pd16 m40">
        <van-button class="btn_bg" v-if="param.status==null || param.status==1" round block type="default" size="large" @click="onSubmit">{{param.status==1?'审核未通过，重新提交':'提交申请'}}</van-button>
        <van-button class="btn_bg" v-if="param.status==2" round block type="default" size="large" >审核通过</van-button>
        <van-button class="btn_bg" v-if="param.status==0" round block type="default" size="large" >审核中</van-button>
      </div>
  
      
    </div>
  </template>


<script>
import { getOrgInfo,saveOrgInfo,getDictData } from '../../api/custom';
export default {
    data() {
        return {
            member_type_list:[],
            orgType:"",
            showOrgTypePick:false,
            org_nature_list:[],
            orgNature:"",
            showOrgNaturePick:false,
            member_job_list:[],
            member_industry_list:[],
            orgMemberJob:"",
            
            showOrgMemberJobPick:false,
            orgIndustry:'',
            showOrgMemberIndustry:false,
            param:{
                orgTypes:0,
                status:null,
                orgIndustry:0,
                orgAttribute:0,
                orgName:"",
                orgFrName:"",
                orgFrJob:"",
                orgFrPhone:"",
                orgDirectorName:"",
                orgDirectorPhone:"",
                contactName:"",
                contactPhone:"",
                orgTel:"",
                orgAddress:"",
                mailCode:"",
                reasons:"",
                remarks:"",
    
            }
        }
    },
    created(){
     this.getDict();
   
    },
    methods: {
        confirmOrgType(value, index){
            console.log(`当前值：${value}, 当前索引：${index}`)
            this.orgType = this.member_type_list[index].dictLabel
            this.param.orgType = this.member_type_list[index].dictValue
            this.showOrgTypePick = false
        },
        confirmOrNature(value, index){
            console.log(`当前值：${value}, 当前索引：${index}`)
            this.orgNature = this.org_nature_list[index].dictLabel
            this.param.orgNature = this.org_nature_list[index].dictValue
            this.showOrgNaturePick = false
        },
        confirmOrgMemberJob(value, index){
            console.log(`当前值：${value}, 当前索引：${index}`)
            this.orgMemberJob = this.member_job_list[index].dictLabel
            this.param.orgFrJob = this.member_job_list[index].dictValue
            this.showOrgMemberJobPick = false
        },
        confirmOrgIndustry(value, index){
            console.log(`当前值：${value}, 当前索引：${index}`)
            this.orgIndustry = this.member_industry_list[index].dictLabel
            this.param.orgIndustry = this.member_industry_list[index].dictValue
            this.showOrgMemberJobPick = false
        },
        async getDict(){
            //会员类别
            await getDictData("member_type").then(res=>{
                this.member_type_list = res.data.list
            });
            //行业性质
            await getDictData("member_industry").then(res=>{
                this.member_industry_list = res.data.list
            });
            //单位性质
            await getDictData("org_nature").then(res=>{
                this.org_nature_list = res.data.list
            });
            // 会员职位
            await getDictData("member_job").then(res=>{
                this.member_job_list = res.data.list
            });
            await  this.getOrg();
        },
        onSubmit(){
            if(this.param.id !=null && this.param.status ==0){
                this.$dialog.alert({
                        title: '审核中',
                        message: '通知管理员进行审核',
                    })
            }
            saveOrgInfo(this.param).then(res=>{
                if(res.success){
                    this.$dialog.alert({
                        title: '提交成功',
                        message: '通知管理员进行审核',
                    }).then(() => {
                        this.getOrg()
                    })
                }
            })
        },
        getOrg(){
            getOrgInfo().then(res=>{
                if(res.data.orgInfo !=null){
                    this.param=res.data.orgInfo
                    this.orgType=this.getOrgType(this.param.orgTypes)
                    this.orgNature=this.getOrgNature(this.param.orgAttribute)
                    this.orgMemberJob=this.getMemberJob(this.param.orgFrJob)
                    this.orgIndustry=this.getMemberIndustry(this.param.orgIndustry)
                }
               
            })
        },
        getOrgType(val) {
            let result = ""
            this.member_type_list.forEach(item => {
                if (item.dictValue == val) {
                result = item.dictLabel
                }
            })
            return result;

        },
        getOrgNature(val) {
            let result = ""
            this.org_nature_list.forEach(item => {
                if (item.dictValue == val) {
                result = item.dictLabel
                }
            })
            return result;

        },
        getMemberJob(val) {
            let result = ""
            this.member_job_list.forEach(item => {
                if (item.dictValue == val) {
                result = item.dictLabel
                }
            })
            return result;

        },
        getMemberIndustry(val) {
            let result = ""
            this.member_industry_list.forEach(item => {
                if (item.dictValue == val) {
                result = item.dictLabel
                }
            })
            return result;

        },
        onClickLeft() {
            this.$router.back()
        },
        onClickRight() {
        this.$router.push("/home")
        //Toast('按钮');
        },
    }
}

</script>